import React from "react";
import { Row, Col, Card, Form, Input, Space } from "antd";
import { PlusCircleOutlined, DeleteOutlined } from "@ant-design/icons";
const { TextArea } = Input;

const Layout4 = ({ onChange, initialData }) => {
  const [form] = Form.useForm();

  return (
    <Card
      style={{
        background: "#f9fafb",
        border: "2px dashed #1890ff",
      }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialData}
        onValuesChange={(_, allValues) => onChange(allValues)}
      >
        {/* Small Title */}
        <Form.Item label="Small Title" name="smallTitle">
          <Input placeholder="About Us" />
        </Form.Item>
        {/* Main Title */}
        <Form.Item label="Main Title" name="mainTitle">
          <Input placeholder="We are crafting your unique business consulting ideas." />
        </Form.Item>
        {/* Dynamic 2-column card layout */}
        <Form.List name="cards" initialValue={[{}, {}, {}]}>
          {(fields, { add, remove }) => (
            <>
              <Row gutter={[24, 24]}>
                {fields.map((field, index) => (
                  <Col xs={24} sm={12} md={8} key={field.key}>
                    <Card
                      bordered={false}
                      style={{
                        background: "#fff",
                        borderRadius: 12,
                        boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                        height: "100%",
                      }}
                    >
                      {/* Image URL */}
                      <Form.Item
                        label="Icon / Image URL"
                        name={[field.name, "image"]}
                      >
                        <Input placeholder="Paste icon or image URL" />
                      </Form.Item>
                      {/* Title */}
                      <Form.Item
                        label="Title"
                        name={[field.name, "title"]}
                      >
                        <Input placeholder="Finance Consultant" />
                      </Form.Item>
                      {/* Description */}
                      <Form.Item
                        label="Description"
                        name={[field.name, "description"]}
                      >
                        <TextArea
                          rows={2}
                          placeholder="Sed ut perspiciatis unde omnis iste natus error sit."
                        />
                      </Form.Item>

                      <Form.Item
                        label="Navigate to"
                        name={[field.name, "navigate_to"]}
                      >
                        <Input placeholder="Navigation page url" />
                      </Form.Item>

                      {/* Actions */}
                      <Space>
                        {index === fields.length - 1 && (
                          <PlusCircleOutlined
                            style={{ fontSize: 18, color: "#1890ff" }}
                            onClick={() => add()}
                          />
                        )}
                        {fields.length > 1 && (
                          <DeleteOutlined
                            style={{ fontSize: 18, color: "red" }}
                            onClick={() => remove(field.name)}
                          />
                        )}
                      </Space>
                    </Card>
                  </Col>
                ))}
              </Row>
            </>
          )}
        </Form.List>
      </Form>
    </Card>
  );
};

export default Layout4;